export default __webpack_public_path__ + "static/media/fad-filter-shelving-hi.ce245091.svg";